import { ElementRef, QueryList, ViewChildren } from '@angular/core';
import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef, forwardRef, HostListener, ViewChild } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorDO } from 'app/BaseFramework/shared/models/error.model';
import * as dict from 'spelling/dictionaries/en_US.js'
import * as spelling from 'spelling/'
import * as flat from 'flat'

import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  AppMetadataHandler
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as moment from 'moment/moment';
import { map, delay } from 'rxjs/operators';
import { of, zip } from 'rxjs';
import { FormCrudService } from 'app/ViewModules/shared-services/form-crud/form-crud.service';
import { NzInputDirective } from 'ng-zorro-antd/input';

interface ValidationOutput {
  isInvalid: boolean,
  errorDOs: Array<ErrorDO>
}

@Component({
  selector: 'app-light-grid',
  templateUrl: './light-grid.component.html',
  styleUrls: ['./light-grid.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LightGridComponent),
      multi: true
    }
  ]
})
export class LightGridComponent implements OnInit, ControlValueAccessor {
  baseComponentName = `LightGridComponent`
  _currentComponentName = `LightGridComponent`
  @Input()
  set currentComponentName(value) {
    if (value) this._currentComponentName = value;
  }


  /**
  * 
  * ControlValueAccessor Implementation
  */
  writeValue(obj: any): void {
    if (!obj) obj = {}
    /*let transformedData = this.ServerToUITransform(obj, this.metaDataConfig);
    if (Array.isArray(transformedData))
      this.inputDataForEdit = transformedData
    else {
      this.inputDataForEdit = []
      this.msg.error(`Configuration Error - The fieldMapping for light-grid ${this.getCurrentComponentName()} is not a list`)
    }*/
    this.initGridForm(this.inputDataForEdit)
    this._initialPayload = this.commonUtilty.deepCopy(obj)
  }
  propagateChange = (_: any) => { };
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {
  }
  setDisabledState?(isDisabled: boolean): void { }

  /**
    * Component Usage Example: All Inputs are Mandatory
    * <app-light-grid [IO]="payloadInEdit 
    * [currentComponentName]="'QuestionnaireComponent'" [metaDataConfig]='formMetaData"
    * (componentOutput)="_BaseEmitHandler($event, 'QuestionnaireComponent')"></app-light-grid>
    */

  constructor(private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private interactService: InteractService,
    public appMetadataHandler: AppMetadataHandler,
    private msg: NzMessageService,
    private formCrudService: FormCrudService) { }

  i = 0;
  currentRow: Number | null;
  listOfDisplayData = []
  lookup$ = {}
  //sortValue: 'ascend' | 'descend' | null = null;
  /**
   *
   *  Ninad: Whenever any developer is creating a new Component,
   * please make sure that you copy all import commands, constructor and
   * Boiler and Component Creation Kickstart CODE 
   *
   * 
   * Component Creation Kickstart CODE   
   */

  //ComponentSpecific Inputs, Outputs
  @Output() componentOutput = new EventEmitter<any>()
  @Input() disabled: boolean;
  @Input() prefillFirstEmptyRow: boolean
  @Input() disablePopupMode: any
  @ViewChild(NzInputDirective, { read: ElementRef }) inputElement: ElementRef;
  @ViewChildren('td') cells: QueryList<ElementRef>;
  lookupValueListMap = {}
  private _lookupData = {}
  set lookupData(lookupResponse: any) {
    if (this.commonUtilty.isArrayIterable(lookupResponse)) {
      lookupResponse.forEach(lookupRes => {
        if (this.commonUtilty.isArrayIterable(lookupRes))
          this._lookupData[lookupRes[0].lookupCd] = this.commonUtilty.deepCopy(lookupRes)
      });
    }
  }

  get lookupData() {
    return this._lookupData
  }
  private formArrayKeyName: string = 'lightGridData'
  private _metaDataConfig
  @Input()
  ignoreValidationFields = {
    // State: [List of Fields]
  }
  @Input()
  set metaDataConfig(value) {
    if (value) {
      this._metaDataConfig = this.commonUtilty.deepCopy(value)

      //chaining
      this.maxDepth = this._calculateMaxDepthForGrid(this._metaDataConfig)
      this._extractLookups(this._metaDataConfig).subscribe(res => this.lookupData = res)
    }
  }
  get metaDataConfig() {
    return this._metaDataConfig
  }

  @Input()
  set IO(value: any) {
    if (value) {
      this._inputDataForEdit = this.ServerToUITransform(value,this.metaDataConfig);
      this._initialPayload = this.commonUtilty.deepCopy(value)
    }
  };

  
  private maxDepth

  private _calculateMaxDepth(metaData) {
    if (metaData && metaData.columns && Array.isArray(metaData.columns)) {
      let depthSizes = []
      metaData.columns.forEach(column => {
        if (column.fieldMapping) {
          depthSizes.push(column.fieldMapping.split('-').length)
          //chaining
          this.extractElementFromArray = /\d/.test(column.fieldMapping)
        }
      });
      return Math.max(...depthSizes)
    }
  }

  private _calculateMaxDepthForGrid(metaData) {
    if (metaData.fieldMapping)
      return metaData.fieldMapping.split('-').length
    else
      return 0
  }

  private _extractLookups(metaData) {

    if (metaData && metaData.columns && Array.isArray(metaData.columns)) {
      let lookupSubjectsList = []
      metaData.columns.forEach(column => {
        if (column.fieldType == 'COMBO' && column.lookupCd) {
          this.lookup$[column.lookupCd] = this.lookupDataService.getLookup(column.lookupCd)
          lookupSubjectsList.push(this.lookupDataService.getLookup(column.lookupCd))
        }
      });

      const a$ = zip(lookupSubjectsList);

      const result$ = a$.pipe(
        map(results => results)
      )

      return result$
    }
    else {
      return of(null)
    }
  }

  get flatteningSafetyValue() {
    if (this.maxDepth > 1) {
      return 'unsafe'
    }
    else {
      return 'safe'
    }
  }

  private _extractElementFromArray = false
  set extractElementFromArray(value) {
    if (value)
      this._extractElementFromArray = value
  }
  get extractElementFromArray() {
    return this._extractElementFromArray
  }

  private _transactionState
  @Input()
  set transactionState(value) {
    if (value) {
      this._transactionState = value
    }
    else {
      // TODO derive transactionState From Meta Data
    }
  }
  get transactionState() {
    return this._transactionState
  }

  environment = environment
  parentEvent$
  currencyOptions = {
    prefix: this.appMetadataHandler.baseCurrencyPREFIX,
    thousands: this.appMetadataHandler.THOUSANDS_SEPARATOR,
    decimal: this.appMetadataHandler.DECIMAL_SEPARATOR
  }

  @HostListener('window:click', ['$event'])
  handleClick(e: MouseEvent): void {
    if (typeof this.currentRow == 'number' && this.currentFieldKey && this.inputElement && this.inputElement.nativeElement !== e.target) {
      this.currentRow = null;
      this.currentFieldKey = null
    }
  }

  currentFieldKey = null
  currentElement = null
  startEdit(rowIndex: Number, fieldKey: string, event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.currentElement = event.target
    this.currentRow = rowIndex;
    this.currentFieldKey = fieldKey
  }

  ngOnInit(): void {
    //this.detectChangeAndPropagateData(this.lightGridForm)
  }

  /**
   * Emit, Transforms and Validation Handlers
   */
  private _initialPayload
  private _inputDataForEdit
  set inputDataForEdit(value: any) {
    if (value) {
      this._inputDataForEdit = value;
      this.listOfDisplayData = [...this._inputDataForEdit]
    }
  };

  get inputDataForEdit() {
    return this._inputDataForEdit
  }

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput, this.UItoServerTransform, this.baseComponentName)
    return c
  }
  getParentComponent(): Component {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
 } catch{}
  }
  getParentComponentName(): string {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
 } catch{}
  }
  getCurrentComponentName(): string {
    return `${this._currentComponentName}`
  }

  UItoServerTransform(payload, response) {
   
    let DO = this.commonUtilty.getDOName(payload)
    let flattenedIO = this.commonUtilty.plainflattenObject(payload, this.flatteningSafetyValue, this.maxDepth)
    let metaData 
    if(this.commonUtilty.isArrayIterable(response.componentData.lightGridData))
     metaData = response.componentData.lightGridData.find(item => true).fieldMetaData

    if (payload && payload[DO] && flattenedIO && metaData && metaData.fieldMapping) {

      let clonedLightGridData = this.commonUtilty.deepCopy(response.componentData.lightGridData)
      clonedLightGridData.forEach(element => {
        delete element['fieldMetaData']
     }); 

     if(flattenedIO[metaData.fieldMapping] && this.commonUtilty.isArrayIterable(flattenedIO[metaData.fieldMapping])){
      flattenedIO[metaData.fieldMapping].forEach((dataObj,index) => {
        Object.assign(dataObj, clonedLightGridData[index]);
      });
     }

   // flattenedIO[metaData.fieldMapping] = response.componentData.lightGridData.map(data => delete data.fieldMetaData);
    }

    
    /**
     * Datatype wise manipulations
     */
    let fieldKeyWiseParentRowMetaData = this.commonUtilty.convertArrayToMap(metaData.columns, 'fieldKey')
    
  if(this.commonUtilty.isArrayIterable(flattenedIO[metaData.fieldMapping])) {
      flattenedIO[metaData.fieldMapping].forEach((parentRow, parentIndex) => {
        for (const parentRowFieldKey in parentRow) {
          if (fieldKeyWiseParentRowMetaData[parentRowFieldKey]) {
            if (fieldKeyWiseParentRowMetaData[parentRowFieldKey].fieldType == 'DATE' && !fieldKeyWiseParentRowMetaData[parentRowFieldKey].ignoreDateTimeConversion) {
              flattenedIO[metaData.fieldMapping][parentIndex][parentRowFieldKey] = this.commonUtilty.UIDOtoServerDODate(parentRow[parentRowFieldKey])
            }
            else if (fieldKeyWiseParentRowMetaData[parentRowFieldKey].fieldType == 'TIME' && !fieldKeyWiseParentRowMetaData[parentRowFieldKey].ignoreDateTimeConversion) {
              flattenedIO[metaData.fieldMapping][parentIndex][parentRowFieldKey] = this.commonUtilty.UIDOtoServerDOsetTime(parentRow[parentRowFieldKey])
            }
            else if (fieldKeyWiseParentRowMetaData[parentRowFieldKey].fieldType == 'COMBO') {
              if (fieldKeyWiseParentRowMetaData[parentRowFieldKey] && fieldKeyWiseParentRowMetaData[parentRowFieldKey].comboMode == 'multiple') {
                if (fieldKeyWiseParentRowMetaData[parentRowFieldKey].comboBindingType == 'CSV')
                  flattenedIO[metaData.fieldMapping][parentIndex][parentRowFieldKey] = this.commonUtilty.convertArrayToCSV(parentRow[parentRowFieldKey])
              }
            }
          }
        }
      })
    }
    /**
     * Datatype wise manipulations Ends
     */
    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    let output = this.commonUtilty.plainUnflattenObject(flattenedIO, this.flatteningSafetyValue, this.maxDepth)
    return output
  }

  ServerToUITransform(payload, metaData) {
    let DO = this.commonUtilty.getDOName(payload);
    let flattenedIO = this.commonUtilty.plainflattenObject(payload, this.flatteningSafetyValue, this.maxDepth)
    let output = [];
    if (payload && payload[DO] && flattenedIO) {
      if (flattenedIO[metaData.fieldMapping]) output = this.commonUtilty.plainUnflattenObject(flattenedIO[metaData.fieldMapping], this.flatteningSafetyValue, this.maxDepth);
    }
    return output;
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      const matches = param.filter(s => s.includes(this.getCurrentComponentName()));
      if (this.commonUtilty.isArrayIterable(param) && this.commonUtilty.isArrayIterable(matches)) {
        let validationResult = this.validateOutput(this.lightGridForm)
        if (!validationResult.isInvalid) {
          // let output = { metaData: this.FORMMETADATAFACTORY, form: this.FormObject }
          // this.EmitComponentOutput(output)
        }
        else {
          this.EmitComponentOutput(validationResult)
        }
      }
      else {
        console.warn(`${this.getCurrentComponentName()} recieved the ping, but is not a emitter child for current transaction type.`)
      }
    })
  }


  validateOutput(o): ValidationOutput {
    this.commonUtilty.markAllFieldDirty(o);
    let errorDOs = this.checkInvalidAndEmptyFields(o, this.getCurrentComponentName(), this.metaDataConfig)
    let validationOutput: ValidationOutput = {
      isInvalid: this.commonUtilty.isArrayIterable(errorDOs),
      errorDOs: errorDOs
    }
    return validationOutput
  }

  //Emit, Transforms and Validation Handlers Ends

  /**
   * Form Manipulations
   */

  lightGridForm: FormGroup;
  get listOfRows(): FormArray {
    return this.lightGridForm.get(this.formArrayKeyName)['controls'] || []
  }

  initGridForm(data?) {
    let output = data || []
    this.lightGridForm = this.fb.group({
      [this.formArrayKeyName]: this.fb.array([])
    });
    this.populateDataToGridForm(output)
    this.detectChangeAndPropagateData(this.lightGridForm)
  }


  populateDataToGridForm(data) {
    let initValue
    if (this.prefillFirstEmptyRow)
      initValue = [{}]
    else
      initValue = []
    let output = data && (Array.isArray(data) && data.length == 0) ? initValue : data
    if (this.commonUtilty.isArrayIterable(output)) {
      output.forEach(rowItem => {
        this.addRow(rowItem);
      });
    }
  }

  initRowForm(metaData, data?, index?): FormGroup {
    let value = this.formCrudService.initRowForm(metaData, data, index)
    return value
  }

  addRow(data?) {
    this.lightGridForm = this.formCrudService.addRow(this.lightGridForm, this.formArrayKeyName, this.metaDataConfig, data)
    this.listOfDisplayData = [...this.lightGridForm.value[this.formArrayKeyName]];
    this.detectChangeAndPropagateData(this.lightGridForm)
    this._toggleRefreshGrid()
    //this.search()
  }

  removeRow(index: number) {
    this.lightGridForm = this.formCrudService.removeRow(this.lightGridForm, this.formArrayKeyName, index)
    this.listOfDisplayData = [...this.lightGridForm.value[this.formArrayKeyName]];
    this._toggleRefreshGrid()
    //this.search()
  }

  setValueOnGrid(index, fieldKey, fieldValue) {
    this.lightGridForm = this.formCrudService.setValueOnGrid(this.lightGridForm, this.formArrayKeyName, index, fieldKey, fieldValue)
  }

  getValueFromGrid(index, fieldKey) {
    let value = this.formCrudService.getValueFromGrid(this.lightGridForm, this.formArrayKeyName, index, fieldKey)
    return value
  }

  resetValueOnGrid(index, fieldKey) {
    let formItem = this.formCrudService.resetValueOnGrid(this.lightGridForm, this.formArrayKeyName, index, fieldKey)
  }

  checkInvalidAndEmptyFields(form: FormGroup, componentName, formMetaData) {
    let invalidFields = [];
    let FormFieldNameMap = this.commonUtilty.convertArrayToMap(formMetaData, 'fieldKey')
    if (form && !form.valid) {
      for (const i in form.controls) {
        let controlName = this.commonUtilty.getControlName(form.controls[i])
        let validationErrorList = this.validationUtilService.getUIErrorList(form.get(controlName), formMetaData.fieldKey)
        if (form.controls[i].status === 'INVALID') {
          validationErrorList.forEach(validationError => {
            let errorDO = new ErrorDO();
            errorDO.errorMsg = validationError.errorMessage;
            errorDO.validationLevel = validationError.validationLevel
            errorDO.fieldName = controlName;
            errorDO.fieldNameDescription = FormFieldNameMap[controlName].fieldName
            errorDO.componentName = componentName;
            invalidFields.push(errorDO)
          })
        }
      }
    }
    if (this.ignoreValidationFields[this.transactionState] && this.commonUtilty.isArrayIterable(this.ignoreValidationFields[this.transactionState])) {
      let tempArray = [];
      invalidFields.forEach(invalidField => {
        if (!this.ignoreValidationFields[this.transactionState].includes(invalidField.fieldName))
          tempArray.push(invalidField);
      });
      invalidFields = tempArray;
    }
    return invalidFields;
  }

  detectChangeAndPropagateData(form) {
    if (form) {
      //let firstOutput = this.commonUtilty.deepCopy(form.value)
      let firstOutput = form.value
      //this.propagateChange(firstOutput)
      form.valueChanges.subscribe(e => {
        let formData = form.value || []
        if (this.commonUtilty.isArrayIterable(formData[this.formArrayKeyName])) {
          this.propagateChange(this.EmitComponentOutput(formData) )
        }
        else {
          this.propagateChange(this._inputDataForEdit)
        }
      })
    }
  }

  isRequired(fieldName, formName?) {
    let nameOfForm = null
    if (formName) {
      nameOfForm = formName
    }
    else {
      nameOfForm = this.metaDataConfig.fieldKey
    }
    let returnObj = this.validationUtilService.isRequired(fieldName, nameOfForm)
    return returnObj
  }



  //Form Manipulations End


  /**
   * Search and Filter Utils
   */

  //searchValue = '';
  //sortName: string | null = null;
  //listOfFilterAddress = [{ text: 'London', value: 'London' }, { text: 'Sidney', value: 'Sidney' }];
  //listOfSearchAddress: string[] = [];
  // reset(): void {
  //   this.searchValue = '';
  //   this.search();
  // }

  // sort(sortName: string, value: any): void {
  //   this.sortName = sortName;
  //   this.sortValue = value;
  //   this.search();
  // }

  // filterAddressChange(value: string[]): void {
  //   this.listOfSearchAddress = value;
  //   this.search();
  // }

  //search(): void {
    //   const filterFunc = (item: any) => {
    //     return (
    //       (this.listOfSearchAddress.length
    //         ? this.listOfSearchAddress.some(address => item.address.indexOf(address) !== -1)
    //         : true) && item.name.indexOf(this.searchValue) !== -1
    //     );
    //   };
    //   const data = this.inputDataForEdit.filter((item: any) => filterFunc(item));
    //   this.listOfDisplayData = data.sort((a, b) =>
    //     this.sortValue === 'ascend'
    //       ? a[this.sortName!] > b[this.sortName!]
    //         ? 1
    //         : -1
    //       : b[this.sortName!] > a[this.sortName!]
    //         ? 1
    //         : -1
    //   );
  //}
  //Search And Filter Utils end

  /**
   * Dynamic Form Handlers
   * 
   */

  formOutput
  _dynamicFormPayload
  set dynamicFormPayload(value) {
    if (value) {
      this._dynamicFormPayload = value
    }
    else {
      this.formOutput = null
    }
  }
  get dynamicFormPayload() {
    return this._dynamicFormPayload
  }

  refreshDynamicComponentToggle = true
  private _toggleRefreshComponent() {
    this.refreshDynamicComponentToggle = false;
    setTimeout(() => { this.refreshDynamicComponentToggle = true; }, 100);
  }

  refreshGridToggle = true
  private _toggleRefreshGrid() {
    this.refreshGridToggle = false;
    setTimeout(() => { this.refreshGridToggle = true; }, 100);
  }

  addDataToGrid(data) {
    this.addRow(data)
    this.formOutput = 'nullify'
    this.closeModal()
  }

  //Dynamic Form Handlers End


  /**
   * Modal Handlers
   */

  _dataCaptureModal
  set dataCaptureModal(value) {
    this._dataCaptureModal = value
  }
  get dataCaptureModal() {
    return this._dataCaptureModal
  }

  openModal() {
    this.dataCaptureModal = true
  }

  closeModal() {
    this.dataCaptureModal = false
  }

  editInPopup(data = {}) {
    //defaulting data to emptyObject handles edit as well as new mode
    this.dynamicFormPayload = this.commonUtilty.deepCopy(data)
    this.openModal()
  }

  fetchDataAndEdit(rowData) {
    let rowMetaData = rowData.fieldMetaData
    let fetchQueryParam = rowData[rowMetaData.entityFetchBy]
    if (rowMetaData && rowData) {
      //fetchCall
      if (rowMetaData.entityFetchURL && fetchQueryParam) {
        this.msg.info(`Fetching Data. . .`)
        let url = !rowMetaData.entityFetchURL.endsWith("/") ? `${rowMetaData.entityFetchURL}/${fetchQueryParam}` : `${rowMetaData.entityFetchURL}${fetchQueryParam}`;
        this.apiRequestService.get(url).subscribe(resp => {
          this.editInPopup(resp)
        })
      }
      else {
        this.editInPopup(rowData)
      }
    }
  }

  openPopupToAddNewData() {
    this.editInPopup()
  }

  /**
   * Sort, Search And Filter Functionality
   */
  //TODO : Below sort and filter functionality is not working, need to update the filteredDataList and render data based on filteredDataList on html template
  sortName: string | null = null;
  sortValue: string | null = null;
  sort(sort: { key: string; value: string }): void {
    this.filterOrSort = 'SORT';
    this.sortName = sort.key;
    this.sortValue = sort.value;

    /*if (this.sortName && this.sortValue) {
      let orderBy = this.sortValue === 'ascend' ? 'asc' : 'desc';
      this.listOfRows = this.commonUtilty.deepCopy(this.commonUtilty.sortObject(this.sortName, this.listOfRows, orderBy))
    } else {
      //this.listOfRows = this.originalListOfRows;
    }
    console.log("sorted listOfRows", JSON.stringify(this.listOfRows));*/
  }

  filterOrSort: string = 'FILTER';
  searchValue: null;
  filterKey = null;
  filteredDataList = [];

  filterMenuVisibilityChanged(event, key) {
    if(event){
      this.searchValue = null;
      this.filterKey = key;
    }    
  }

  getConfigKey(key) {
    this.filterOrSort = 'FILTER';
    this.filterKey = key;
  }

  /*searchConfiguration(value) {
    if (value) {
      this.listOfRows = this.originalListOfRows.filter(item => (item.controls[this.filterKey] && item.controls[this.filterKey].value) ? item.controls[this.filterKey].value.toLowerCase().includes(value.toLowerCase()) : []);
      this.searchValue = null;
    }
  }*/

  reset(): void {
    this.filterOrSort = 'FILTER';
    this.searchValue = null;
  }

  /**
   *END:  Search And Filter Functionality
   */
  
  /**
   * Row Selection on Grid
   * **/
  /*deselectOtherRows(event, data, rowIndex,key) {
      if(this.commonUtilty.isArrayIterable(this.lightGridForm.get(this.formArrayKeyName)['controls'])){
        this.lightGridForm.get(this.formArrayKeyName)['controls'].forEach((element, indx) => {
          if(indx != rowIndex){
           this.lightGridForm.controls.lightGridData['controls'][indx]['controls'][key].value = false;
          }else{
           this.lightGridForm.controls.lightGridData['controls'][rowIndex]['controls'][key].value = event;
          }
        });
      }
  }*/

  deselectOtherRows(event,row, rowIndex,key) {
    if(this.commonUtilty.isArrayIterable(this.lightGridForm.get(this.formArrayKeyName)['controls'])){
      this.lightGridForm.get(this.formArrayKeyName)['controls'].forEach((element, indx) => {
        if(indx != rowIndex){
          this.setValueOnGrid(indx, key, false);
        }else{
          this.setValueOnGrid(rowIndex, key, event.target.checked);
        }
      });
    }
  }

  selectAllCheckbox(event, key){
    if(this.commonUtilty.isArrayIterable(this.lightGridForm.get(this.formArrayKeyName)['controls'])){
      this.lightGridForm.get(this.formArrayKeyName)['controls'].forEach((element, indx) => {
        this.setValueOnGrid(indx, key, event.target.checked);
      });
    }
  }

  /**
   * END: Row Selection on Grid
   * **/
  
}
